// Repositions the Kustomer chat iframe above the sticky add-to-cart bar.
const stickyBarKustomer = document.querySelector("product-add-to-cart-sticky");

if (stickyBarKustomer) {
  const TRANSITION = "bottom 0.25s cubic-bezier(0.104, 0.204, 0.492, 1)";
  const DEFAULT = "20px";
  const mobileQuery = window.matchMedia("(max-width: 767px)");

  // Persistent <style> tag — overrides SDK inline styles via !important
  const styleEl = document.createElement("style");
  styleEl.id = "kustomer-sticky-override";
  document.head.appendChild(styleEl);

  function repositionKustomer() {
    const isVisible = stickyBarKustomer.classList.contains("sticky--visible");
    const isMobile = mobileQuery.matches;
    const bottom = isVisible ? (isMobile ? "160px" : "180px") : DEFAULT;
    const right = isVisible ? (isMobile ? "5px" : "20px") : DEFAULT;

    styleEl.textContent = `
      #kustomer-ui-sdk-iframe {
        bottom: ${bottom} !important;
        right: ${right} !important;
        transition: ${TRANSITION} !important;
      }
    `;
  }

  // On mobile: detect chat modal open/close via iframe resize
  function setupChatOpenDetection(iframe) {
    new ResizeObserver(() => {
      if (!mobileQuery.matches) return;
      const isChatOpen = iframe.offsetHeight > 200;
      if (isChatOpen) {
        styleEl.textContent = `
          #kustomer-ui-sdk-iframe {
            bottom: 0 !important;
            right: 0 !important;
            transition: none !important;
          }
        `;
      } else {
        repositionKustomer();
      }
    }).observe(iframe);
  }

  // Watch for the iframe being injected into the DOM late
  const iframeObserver = new MutationObserver(() => {
    const iframe = document.getElementById("kustomer-ui-sdk-iframe");
    if (iframe) {
      repositionKustomer();
      setupChatOpenDetection(iframe);
      iframeObserver.disconnect();
    }
  });
  iframeObserver.observe(document.body, { childList: true, subtree: true });

  new MutationObserver(repositionKustomer).observe(stickyBarKustomer, {
    attributeFilter: ["class"],
  });
  mobileQuery.addEventListener("change", repositionKustomer);
  repositionKustomer();
}
